import { useAuth } from 'context/AuthProvider.js';
import { httpClient } from 'helpers/HttpClient.js';
import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Form, FormControl, Row } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { ApiEndpoint } from 'helpers/ApiEndPoint.js';
import PropTypes from 'prop-types';
const URI = ApiEndpoint + 'configuration/';
const EditTipoEvento = ({ idTipoEvento, closeModal }) => {
  const Auth = useAuth();
  var userData = Auth.getSessionData();
  const [tipoEvento, setTipoEvento] = useState({
    clave: '',
    descripcion: ''
  });
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors }
  } = useForm();

  const getTipoEvento = async () => {
    setTipoEvento(null);

    httpClient('GET', URI + 'eventtypes/' + idTipoEvento, {}, userData.token)
      .then(function (response) {
        if (!response.data.error) {
          setValue('clave', response.data.clave);
          setValue('descripcion', response.data.descripcion);
        }
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => {});
  };

  const onSubmit = data => {
    console.log(data);

    if (idTipoEvento > 0) {
      httpClient(
        'put',
        URI + 'eventtypes/' + idTipoEvento,
        {
          clave: data.clave,
          descripcion: data.descripcion
        },
        userData.token
      )
        .then(function (response) {
          if (!response.data.error) {
            closeModal();
          }
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(() => {});
    } else {
      httpClient(
        'POST',
        URI + 'eventtypes',
        {
          clave: data.clave,
          descripcion: data.descripcion
        },
        userData.token
      )
        .then(function (response) {
          if (!response.data.error) {
            closeModal();
          }
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(() => {});
    }
  };
  useEffect(() => {
    console.log(idTipoEvento);
    if (idTipoEvento > 0) getTipoEvento();
  }, []);
  return (
    <Card style={{ width: '100%' }}>
      <Card.Body>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Row>
            <Col>
              <Form.Group className="mb-4">
                <Form.Label>Clave</Form.Label>
                <FormControl
                  {...register('clave', {
                    required: 'Clave es requerido',
                    minLength: {
                      value: 2,
                      message: 'La Clave debe tener al menos 2 caracteres'
                    },
                    maxLength: {
                      value: 4,
                      message: 'La Clave debe tener maximo 4 caracteres'
                    }
                  })}
                  type="text"
                  defaultValue={tipoEvento?.clave}
                  isInvalid={!!errors.clave}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.clave?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-4">
                <Form.Label>Descripcion</Form.Label>
                <FormControl
                  {...register('descripcion', {
                    required: 'Descripcion es requerido',
                    minLength: {
                      value: 3,
                      message: 'Descripcion debe tener al menos 4 caracteres'
                    },
                    maxLength: {
                      value: 30,
                      message: 'Descripcion '
                    }
                  })}
                  type="text"
                  defaultValue={tipoEvento?.descripcion}
                  isInvalid={!!errors.descripcion}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.descripcion?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col>
              <Button type="submit" color="primary" size="sm">
                Guardar
              </Button>
            </Col>
          </Row>
        </Form>
      </Card.Body>
    </Card>
  );
};
EditTipoEvento.propTypes = {
  idTipoEvento: PropTypes.number.isRequired,
  closeModal: PropTypes.func
};
export default EditTipoEvento;
